module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir5-e98eb6a35e982f2245c8a610e9617c9c.jpg";